var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#3B5998"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7653 11.4307H11.8025V18.6216H8.82867V11.4307H7.41431V8.90356H8.82867V7.26821C8.82867 6.09876 9.38418 4.26752 11.829 4.26752L14.0318 4.27673V6.72976H12.4335C12.1713 6.72976 11.8027 6.86075 11.8027 7.41861V8.90592H14.0251L13.7653 11.4307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconFacebook);
export default __webpack_public_path__ + "static/media/social-icon-facebook.f1be498a.svg";
export { ForwardRef as ReactComponent };